import { useLocalisation } from "@3plearning/lingui-cdn";
import React from "react";
import { Header } from '@3plearning/react-components';
import StudentAccess from "../student-access/student-access";
import css from "./app-heading.scss";

const AppHeading = () => {
  const { i18n } = useLocalisation();

  return (
    <Header
      title={i18n.t`Assign & Review`}
      subtitle={i18n.t`Skill Quests`}
      className={css.header}
    >
      <div className={css.buttonsContainer}>
        <StudentAccess i18n={i18n} />
      </div>
    </Header>
  )
}

export default AppHeading;


// WEBPACK FOOTER //
// ./components/app-heading/app-heading.js